<template>
    <div class="container">
        <div class="title">选择您本次需要登录的租户</div>
        <div class="label">租户</div>
        <el-form class="form" :model="form">
            <el-form-item>
                <el-select
                    size="large"
                    placeholder="请选择租户"
                    v-model="form.tenantCode"
                >
                    <template v-for="item in tenantList">
                        <el-option
                            :label="item.tenantName"
                            :value="item.tenantCode"
                            :key="item.tenantCode"
                        >
                        </el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="btn btn-primary" @click="hanldeLogin">
                    进入租户
                </div>
            </el-form-item>
            <el-form-item>
                <div class="btn" @click="handleBack">返回登录</div>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    name: 'TenantSelect',
    props: {
        tenantList: {
            type: Array,
            default: () => []
        },
        // 用户返回到登录界面
        step: {
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            form: {
                tenantCode: this.tenantList[0].tenantCode
            }
        };
    },
    methods: {
        // 进入租户
        hanldeLogin() {
            this.$emit('on-login', this.form);
        },
        handleBack() {
            this.$emit('update:step', 1);
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    width: 500px;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
        font-size: 34px;
        font-weight: 600;
        color: #242424;
        line-height: 34px;
        margin-bottom: 32px;
    }
    .label {
        font-size: 14px;
        font-weight: 400;
        color: #2d2e33;
        line-height: 14px;
        margin-bottom: 10px;
    }
    .form {
        width: 335px;
        .btn {
            cursor: pointer;
            width: 100%;
            border: 1px solid #dfe4ed;
            font-size: 16px;
            font-weight: 500;
            color: #2d2f33;
            letter-spacing: 2px;
            border-radius: 4px;
            text-align: center;
            height: 40px;
            line-height: 40px;
            background: transparent;
        }
        .btn-primary {
            border: 0;
            background: #ff585e;
            color: #fff;
        }
    }
}
</style>
